export default __webpack_public_path__ + "99815473b3ec94161fe860cfd7e01fd1.png";